import React from "react";
import RoleBuilderGeneral from "./tabs/RoleBuilderGeneral";
import RoleBuilderPermissions from "./tabs/RoleBuilderPermissions";
import RoleBuilderSystemNotificationTypes from "./tabs/RoleBuilderSystemNotificationTypes";
import RoleBuilderDashboards from "./RoleBuilderDashboards";
import RoleBuilderHistory from "./tabs/RoleBuilderHistory";

export default class RoleBuilderWorkspace extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="tab-content">
        <RoleBuilderGeneral {...this.props} />
        <RoleBuilderPermissions {...this.props} />
        <RoleBuilderSystemNotificationTypes {...this.props} />
        <RoleBuilderDashboards {...this.props} />
        {this.props.read_only && !this.props.system_data ? (
          <RoleBuilderHistory {...this.props} />
        ) : null}
      </div>
    );
  }
}
